import React, { FC, useCallback } from 'react';

import { RouteName } from '../../../../config/clientRoutes/types';
import { useHistory } from 'react-router';
import { useI18nPath } from '../../../../config/clientRoutes/hooks';
import { Link, LinkProps } from '@material-ui/core';

type Props = LinkProps & {
  to: RouteName;
};

const InlineLink: FC<Props> = ({ to, target, children, ...restProps }) => {
  const { getPath } = useI18nPath();
  const { push } = useHistory();

  const handleClick = useCallback(
    (event: React.SyntheticEvent) => {
      event.preventDefault();

      if (target === '_blank') {
        window.open(window.location.origin + getPath(to));
      } else {
        push(getPath(to));
      }
    },
    [push, getPath, target, to]
  );

  return getPath(to) != null ? (
    <Link href={getPath(to)} onClick={handleClick} {...restProps}>
      {children}
    </Link>
  ) : null;
};

export default InlineLink;
